import { Grid, Paper, Table, TableCell, TableHead, TableRow, Typography, makeStyles, useTheme } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import MigaPan from '../../../app/orussystem/component/MigaPan';
import DatosMantenimiento from './datosMantenimiento';
import DatosTablaMantenimiento from './datosTablaMantenimiento';
import { listMantenimiento } from '../../domain/api/MantenimientoApi';
import { ROL_USER } from '../../../app/api-client/constants';
import { useLocation, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
const useStyles = makeStyles((theme) => ({
    title: {
        marginBottom: '30px',
        marginTop: '1%',
        fontFamily: "'Segoe UI Variable Static Display 700', sans-serif",
    },
    TableCell: {
        color: '#0088FE',
        fontFamily: "'Segoe UI Variable Static Display 700', sans-serif",
        fontWeight: 'bold',
        fontSize: '17px',

    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
        width: '100%',
        marginTop: '2%'
    },
}));

export default function Mantenimiento() {
    const dispatch = useDispatch();
    let { id } = useParams();
    const classes = useStyles()
    let rol = localStorage.getItem(ROL_USER)
    const location = useLocation();
    const nameBascula = location.state?.nameBascula;
    const [data, setData] = useState([]);

    const getDataTable = async () => {
        let roles = rol != 'ROLE_ADMIN' ? 0 : 0
        const dataList = await listMantenimiento(dispatch, id, roles);
        try {
            setData(dataList.content);
        } catch (err) {
            console.log("Ocurrio un error", err)
        }
    }

    useEffect(async () => {
        await getDataTable(id);
    }, [id]);
    const theme = useTheme(); // Obtén el tema

    const primaryColor = theme.palette.primary.main;
    return (
        <>
            <Grid item xs={12} >
                <br></br>
                <br></br>
                <MigaPan
                    namePage={`Mantenimiento`}
                    to="/"
                    namePage2="Estaciones"
                    to2="/basculas"
                >
                    Home
                </MigaPan>
            </Grid>

            <Grid item xs={12} md={12} lg={12}>
                <DatosMantenimiento
                    getDataTable={getDataTable}>

                </DatosMantenimiento>
                <Paper className={classes.paper} >


                    <div>
                        <Typography variant="h4" className={classes.title} color='primary'>
                            Mantenimientos {nameBascula}
                        </Typography>

                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                {/* Encabezados de la tabla */}
                                <Table>
                                    <TableHead color='primary'>
                                        <TableRow color='primary'>
                                            <TableCell className={classes.TableCell} style={{ paddingLeft: '3%', color: primaryColor }}>Fecha</TableCell>
                                            <TableCell className={classes.TableCell} style={{ paddingLeft: '5.2%', color: primaryColor }}>Encargado</TableCell>
                                            <TableCell className={classes.TableCell} style={{ paddingLeft: '3%', color: primaryColor }}>Actividad</TableCell>
                                            <TableCell className={classes.TableCell} style={{ paddingLeft: '4%', color: primaryColor }}>Responsable</TableCell>
                                            <TableCell className={classes.TableCell} style={{ paddingLeft: '2.5%', color: primaryColor }}>Descargar</TableCell>
                                            <TableCell className={classes.TableCell} style={{ color: primaryColor }}>Detalle</TableCell>
                                        </TableRow>
                                    </TableHead>
                                </Table>
                            </Grid>
                            <Grid item xs={12}>
                                <DatosTablaMantenimiento data={data} nameBascula={nameBascula} primaryColor={primaryColor} />
                            </Grid>
                        </Grid>

                    </div>
                </Paper>
            </Grid>

        </>
    );


}